import React, { useMemo, useRef } from 'react'
import { isPlainObject, pick, keys } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import CollectorModal from '../../data-operate/Modal'

// clickFn 西城住建项目的新建判重校验弹窗需要关闭加此方法(更名为afterSubmitCallBack)
const Collector = ({ children, extData = {}, afterSubmitCallBack }) => {
  const popupRef = useRef(null)
  const { appendTbData, updateTbData, collectorConfig } = useTbViewStore(
    (state) => pick(state, ['appendTbData', 'updateTbData', 'collectorConfig'])
  )
  const { userInfoInApp } = useAppEx((state) => pick(state, ['userInfoInApp']))

  const showLayouts = collectorConfig && collectorConfig.collectorLayouts
  const defaultValue = (collectorConfig && collectorConfig.defaultValue) || {}

  const createData = (data, afterSubmit) => {
    const props = {}
    const obj = keys(defaultValue).find(
      (v) => defaultValue[v] === 'userInfo.orgName'
    )
    if (obj) {
      props[obj] = userInfoInApp.orgName
    }
    appendTbData({ ...data, ...defaultValue, ...props, ...extData })
      .then((res) => {
        if (res && res.message && res.status === 500) {
          showNotification({
            title: res.message,
          })
        } else {
          afterSubmit()
          if (afterSubmitCallBack) {
            afterSubmitCallBack()
          }
        }
      })
      .catch((err) => {
        if (!isPlainObject(err)) {
          showNotification({
            title: err,
          })
        }
      })
  }

  const editData = (data, afterSubmit) => {
    updateTbData(data).then(() => {
      showNotification({
        title: '操作成功',
      })
      afterSubmit()
    })
  }

  const onClickSubmit = (data, afterSubmit) => {
    if (data.objectId) {
      return editData(data, afterSubmit)
    }

    return createData({ ...data, ...defaultValue, ...extData }, afterSubmit)
  }

  return (
    <CollectorModal
      ref={popupRef}
      title="新建数据"
      data={extData}
      fieldsLayouts={showLayouts}
      onConfirm={onClickSubmit}
      config={collectorConfig}
      trigger={children}
    />
  )
}
export default Collector
